import { useEffect, useState } from 'react';
import {
  ChannelStatusAction,
  SortOrder,
  useFindManyChannelLazyQuery,
  useGetOrCreateActiveClientChannelMutation,
} from 'shared/types/graphql';

type UseFindOrCreateChannelResult = {
  channelId: string | null;
  isLoading: boolean;
  isCalled: boolean;
};

type UseFindOrCreateChannelParams = {
  petParentId?: string;
  createChannelIfNotExists?: boolean;
};

const useFindOrCreateActiveChannel = ({
  petParentId,
  createChannelIfNotExists,
}: UseFindOrCreateChannelParams): UseFindOrCreateChannelResult => {
  const [getOrCreateActiveChannel, { loading: isGetOrCreateChannelLoading, called: isGetOrCreateChannelCalled }] =
    useGetOrCreateActiveClientChannelMutation();
  const [findChannels, { loading: isFindChannelsLoading, called: isFindChannelsCalled }] =
    useFindManyChannelLazyQuery();
  const [channelId, setChannelId] = useState<string | null>(null);

  useEffect(() => {
    if (!petParentId || channelId) {
      return;
    }

    if (createChannelIfNotExists) {
      getOrCreateActiveChannel({
        variables: {
          data: {
            clinicPetParentIds: [petParentId],
          },
        },
      }).then((resp) => {
        setChannelId(resp.data?.getOrCreateActiveClientChannel?.id || null);
      });
    } else {
      findChannels({
        variables: {
          where: {
            channelMembers: {
              some: {
                clinicPetParent: {
                  id: { equals: petParentId },
                },
                removedAt: null,
              },
            },
            channelStatus: {
              channelStatusAction: {
                equals: ChannelStatusAction.Active,
              },
            },
          },
          orderBy: {
            createdAt: SortOrder.Desc,
          },
        },
      }).then((resp) => {
        setChannelId(resp.data?.findManyChannel?.[0]?.id || null);
      });
    }
  }, [petParentId, findChannels, createChannelIfNotExists, getOrCreateActiveChannel, channelId]);

  return {
    channelId,
    isLoading: isGetOrCreateChannelLoading || isFindChannelsLoading,
    isCalled: isGetOrCreateChannelCalled || isFindChannelsCalled,
  };
};

export default useFindOrCreateActiveChannel;
